import { PartnerWorker } from 'partner/shared/services/partner-planner-service.types';
import { PartnerPlannerTableDefinition } from './partner-planner-modal-table.types';

export const getPlannerModalTableData = (
  data: PartnerWorker[]
): PartnerPlannerTableDefinition[] => {
  return data.map((worker) => {
    return {
      worker: {
        name: worker.name,
        partnerName: worker.partnerName,
      },
      email: worker.email,
      phone: worker.phone,
      hasRequiredCertificates: worker.hasRequiredCertificates,
      actions: {
        workerId: worker.id,
        shiftClaimId: worker.shiftClaimId,
      },
      availability: worker.availability,
      contractHoursData: {
        workedMinutes: worker.workedMinutes ?? null,
        contractMinutes: worker.contractMinutes ?? null,
      },
    };
  });
};
